import styles from "./taskcard.module.css";
import { Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Controller, useForm } from "react-hook-form";

const TaskForm = ({ task, saveAnswerConf, date }) => {
    const { handleSubmit, control, errors } = useForm();

    const saveAnswer = async (data, task) => {
        if (task?.task_question_type === 'Checkbox') {
            data = { ...data, answer: data.answer.join(',') };
        }

        saveAnswerConf(data, task, date);
    }

    return (<form onSubmit={handleSubmit((data) => saveAnswer(data, task))}>
        <div className={`${styles.TaskAnsSecUnder}`}>
            <div className={`${styles.Label}`}>Question</div>
            <div className={`${styles.Text}`}>{task.task_question}</div>
            {task.task_is_required === 1 && <span className={`${styles.REQBadge}`}>Required</span>}
            {task.task_question_type === 'Text' && <>
                <Controller
                    name={`answer`}
                    control={control}
                    rules={{ required: task.task_is_required === 1 ? 'This field is required.' : false }}
                    render={(field) => (<textarea {...field} className={`${styles.OpenTextArea}`} defaultValue={task.answer || ''} placeholder="Type your answer…" ></textarea>)}
                />
                {errors.answer && <p className={`${styles.ErrorM}`}>{errors.answer.message}</p>}
            </>}
            {task.task_question_type === 'Yes / No' && <>
                <Controller
                    name={`answer`}
                    control={control}
                    rules={{ required: task.task_is_required === 1 ? "Please select Yes or No" : false }}
                    defaultValue={task.answer || ''}
                    render={({ value, onChange }) => (<div className={styles.YesNoBuRow}>
                        <button type="button" className={`${styles.YesBU} ${value === "Yes" ? styles.NoBU : ""}`} onClick={() => onChange("Yes")}>Yes</button>
                        <button type="button" className={`${styles.YesBU} ${value === "No" ? styles.NoBU : ""}`} onClick={() => onChange("No")}>No</button>
                    </div>)}
                />
                {errors.answer && <p className={`${styles.ErrorM}`}>{errors.answer.message}</p>}
            </>}
            {task.task_question_type === 'Radio Button' && <div className={`${styles.optList}`}>
                <Controller
                    name={`answer`}
                    control={control}
                    defaultValue={task.answer || ""}
                    rules={{ required: task.task_is_required === 1 ? "Please select an option" : false }}
                    render={({ value, onChange }) => (<FormControl>
                        <RadioGroup className={`${styles.RadioOption} RadioOptionTask`} value={value} onChange={(e) => onChange(e.target.value)}>
                            {task.task_answer_options?.map((i) => (<FormControlLabel key={i} value={i} control={<Radio />} label={i} />))}
                        </RadioGroup>
                    </FormControl>)}
                />
                {errors.answer && <p className={`${styles.ErrorM}`}>{errors.answer.message}</p>}
            </div>}
            {task.task_question_type === 'Checkbox' && <div className={`${styles.optList}`}>
                <Controller
                    name={`answer`}
                    control={control}
                    defaultValue={task.answer ? task.answer.split(",") : []}
                    rules={{ validate: (value) => task.task_is_required === 1 && (!value || value.length === 0) ? "Please select at least one option" : true }}
                    render={({ value = [], onChange }) => (<FormControl className={`${styles.RadioOption} RadioOptionTask`}>
                        {task.task_answer_options?.map((option) => (
                            <FormControlLabel
                                key={option}
                                control={<Checkbox
                                    checked={value.includes(option)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            onChange([...value, option]);
                                        } else {
                                            onChange(value.filter((v) => v !== option));
                                        }
                                    }}
                                />}
                                label={option}
                            />
                        ))}
                    </FormControl>)}
                />
                {errors.answer && <p className={`${styles.ErrorM}`}>{errors.answer.message}</p>}
            </div>}

            <button className={`${styles.OpenTextAreaSaveBU}`} type="submit">Save Answer</button>
        </div>
    </form>);
};

export default TaskForm;